import { useState } from 'react';

const CHARACTER_TYPES = [
  {
    type: 'female',
    video: 'https://cdn.lovescape.com/cdn/front/videos/marketing/coveranimegirl.mp4',
    label: 'Female'
  },
  {
    type: 'male',
    video: 'https://cdn.lovescape.com/cdn/front/videos/marketing/coveranimeboy.mp4',
    label: 'Male'
  },
  {
    type: 'trans',
    video: 'https://cdn.lovescape.com/cdn/front/videos/marketing/coveranimetrans.mp4',
    label: 'Trans'
  },
  {
    type: 'creature',
    video: 'https://cdn.lovescape.com/cdn/front/videos/marketing/covercreature.mp4',
    label: 'Creature'
  }
];

const Step1CharacterType = ({ formData, updateFormData, goToStep }) => {
  const [selectedType, setSelectedType] = useState(formData.gender || '');

  const handleSelect = (type) => {
    setSelectedType(type);
    updateFormData('gender', type);
  };

  const handleNext = () => {
    if (selectedType) {
      goToStep(2);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      position: 'relative',
      overflowY: 'auto'
    }}>
      {/* Background images */}
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/s2zgc1ad_nowings.png" 
        alt="Background Left" 
        className="bg-image-left"
      />
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/h9eorbzw_female6.png" 
        alt="Background Right" 
        className="bg-image-right"
      />
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/i4w18itu_9.png" 
        alt="Background Center" 
        className="bg-image-center"
      />

      <h1 style={{
        fontSize: 'clamp(36px, 6vw, 56px)',
        marginBottom: '60px',
        letterSpacing: '4px',
        textAlign: 'center',
        color: '#DA3D57',
        fontWeight: 'bold',
        position: 'relative',
        zIndex: 1
      }} data-testid="step1-heading">
        Choose Your Character Type
      </h1>

      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        overflowX: 'auto',
        gap: '20px',
        width: '100%',
        maxWidth: '1200px',
        padding: '20px',
        scrollbarWidth: 'thin',
        position: 'relative',
        zIndex: 1
      }}>
        {CHARACTER_TYPES.map((char) => (
          <div
            key={char.type}
            style={{
              minWidth: '200px',
              flexShrink: 0,
              textAlign: 'center'
            }}
          >
            <div
              className={`media-item ${selectedType === char.type ? 'selected' : ''}`}
              onClick={() => handleSelect(char.type)}
              style={{
                width: '200px',
                height: '300px',
                aspectRatio: '2/3',
                borderRadius: '12px',
                overflow: 'hidden',
                marginBottom: '12px'
              }}
              data-testid={`character-type-${char.type}`}
            >
              <video
                autoPlay
                muted
                loop
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              >
                <source src={char.video} type="video/mp4" />
              </video>
            </div>
            <div style={{
              fontSize: '24px',
              letterSpacing: '2px',
              color: '#DA3D57',
              fontWeight: 'bold'
            }}>
              {char.label}
            </div>
          </div>
        ))}
      </div>

      <button
        className="btn-primary"
        onClick={handleNext}
        disabled={!selectedType}
        style={{
          marginTop: '60px',
          position: 'relative',
          zIndex: 1
        }}
        data-testid="step1-next-button"
      >
        Next
      </button>
    </div>
  );
};

export default Step1CharacterType;